import React from "react";

const Slider = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "85vh",
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          minWidth: "100%",
          minHeight: "100%",
          transform: "translate(-50%, -50%)",
          objectFit: "cover",
        }}
      >
        <source src="./images/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay Content (optional) */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "end",
          alignItems: "center",
          color: "#fff",
          textAlign: "center",
          background: "rgba(0,0,0,0.3)", // slight dark overlay
        }}
      >
        <img src="./images/bannerimage.png" className="bannerimage" alt="" />
        <h1 className="videotext" >
          Welcome to Sree Ayyappa Temple Borivili
        </h1>
        {/* <p style={{ marginBottom: "15px" }}>
          Online Pooja Booking Available
        </p>
        <button
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            border: "none",
            borderRadius: "5px",
            backgroundColor: "#ff9800",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={() => window.location.href = "/pooja-booking"}
        >
          Book Pooja
        </button> */}
      </div>
    </div>
  );
};

export default Slider;